import React from 'react';
import { SunIcon, MoonIcon } from "@heroicons/react/24/outline";
import { motion } from "framer-motion";
import useThemeStore from "../../store/theme.store";

const Navbar: React.FC = () => {
  const { theme, setTheme } = useThemeStore();
  return (
    <nav className="bg-background text-contentColor shadow-lg">
      <div className="container mx-auto px-4 py-3 flex items-center justify-between relative">
        <div className="flex items-center">
          <img 
            src="/og-omniwot.png"
            alt="Omniwot Logo"
            className="h-8"
          />
        </div>
        <div className="absolute left-1/2 transform -translate-x-1/2">
          <h1 className="text-xl text-contentColor font-bold">Wireless IOT Parking Management</h1>
        </div>
        <div>
        <div className="flex items-center gap-4">
        <div className="flex space-x-4">
          <button className="hover:text-gray-300 bg-transparent border-none text-contentColor cursor-pointer">Overview</button>
          <button className="hover:text-gray-300 bg-transparent border-none text-contentColor cursor-pointer">Map</button>
          <button className="hover:text-gray-300 bg-transparent border-none text-contentColor cursor-pointer">Reports</button>
          <button className="hover:text-gray-300 bg-transparent border-none text-contentColor cursor-pointer">Settings</button>
        </div>
        <button
                onClick={() => setTheme(theme === "golain" ? "dark-default" : "golain")}
                className="relative w-20 h-10 rounded-full bg-background-layer2 cursor-pointer"
                type="button"
                aria-label="Toggle theme"
              >
                <div className="absolute inset-1 flex items-center justify-between px-1">
                  <SunIcon
                    className={`w-5 h-5 transition-opacity ${theme === "golain" ? "opacity-100" : "opacity-40"
                      } text-primaryLight`}
                  />
                  <MoonIcon
                    className={`w-5 h-5 transition-opacity ${theme === "dark-default" ? "opacity-100" : "opacity-40"
                      } text-primaryLight`}
                  />
                </div>
                <motion.div
                  layout
                  className="absolute h-8 w-8 rounded-full shadow-sm bg-primaryLight/50"
                  style={{ top: "4px", left: "4px", right: "4px" }}
                  animate={{
                    x: theme === "golain" ? 0 : 42
                  }}
                  transition={{
                    type: "spring",
                    stiffness: 300,
                    damping: 25
                  }}
                />
              </button>
              </div>
              </div>
      </div>
    </nav>
  );
};

export default Navbar;